<template>
  <div class="page-content">
    <div class="headings d-flex">
      <h2 class="title title-primary">
        {{ $t("lang.admin.print_order.title") }}
      </h2>
    </div>
    <div class="page-main-content">
      <div class="container-fluid">
        <div class="row">
          <bx-box
            :title="
              $tc('lang.admin.print_order.order', totalOrders, {
                count: totalOrders
              })
            "
            color="white"
            no-padding
            :loading="shouldLoading"
            class="col-12"
          >
            <template v-slot:default>
              <skeleton-table :columns="6" v-if="shouldLoading" />
              <bx-table
                :data="data"
                :columns="columns"
                paginated
                v-if="!shouldLoading"
                :currentPage="page"
                :perPage="itemsPerPage"
                backendPagination
                :total="totalOrders"
                @update:currentPage="updatePage"
              >
                <template slot-scope="props">
                  <bx-table-column centered class="pt-5">
                    <router-link
                      :to="`/printer/print/${props.row.id}/detail`"
                      class="bx-link bx-link-bold"
                      >{{ props.row.id }}</router-link
                    >
                  </bx-table-column>

                  <bx-table-column centered class="pt-5">
                    {{ props.row.name }}
                  </bx-table-column>

                  <bx-table-column centered class="pt-5">{{
                    formatDate(props.row.creation_date)
                  }}</bx-table-column>

                  <bx-table-column centered class="pt-5">
                    {{
                      `${props.row.company_format.tag_type.id}_${props.row.company_format.tag_type.reference}`
                    }}
                  </bx-table-column>

                  <bx-table-column centered class="pt-5">{{
                    props.row.company_format.tag_format.description
                  }}</bx-table-column>

                  <bx-table-column centered class="pt-5">{{
                    props.row.state
                  }}</bx-table-column>

                  <bx-table-column centered class="pt-5">{{
                    formatQty(props.row.total_quantity)
                  }}</bx-table-column>

                  <bx-table-column centered class="pt-5">
                    <v-progress-linear
                      :value="props.row.progress"
                      rounded
                      color="#5DC355"
                      height="8"
                    ></v-progress-linear>
                  </bx-table-column>

                  <bx-table-column centered class="pt-2">
                    <v-btn
                      text
                      v-if="props.row.state === 'WORKING'"
                      small
                      @click="confirmCancelPrining(props.row.id)"
                      >{{ $t("lang.admin.printer_form.label_cancel") }}
                    </v-btn>
                    <order-print-form
                      v-else
                      :item="props.row"
                      @refresh-page="getData"
                    ></order-print-form>
                  </bx-table-column>
                </template>
              </bx-table>
            </template>
          </bx-box>
        </div>
      </div>
    </div>

    <!-- confirm -->
    <confirm-dialog ref="confirm"></confirm-dialog>
  </div>
</template>

<script>
import common from "@/utils/common";
import OrderPrintForm from "@/components/OrderPrintForm.vue";
import ConfirmDialog from "@/components/dialogs/ConfirmDialog.vue";

export default {
  components: { OrderPrintForm, ConfirmDialog },
  name: "PrintOrderList",
  mixins: [common],
  data() {
    return {
      selectedAction: null,
      shouldLoading: true,
      dialog: false,
      columns: [],
      data: [],
      totalOrders: 0,
      itemsPerPage: process.env.VUE_APP_ITEMS_PER_PAGE,
      page: 1,
      limit: 10
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    updatePage(p) {
      this.page = p;
      this.getData();
    },
    async getData() {
      try {
        let orders = await this.$api.printer.print_order({
          limit: this.limit,
          offset: (this.page - 1) * this.limit
        });
        this.data = orders.results.map((item, index) => ({
          ...item,
          action: this.selectedAction
        }));
        this.totalOrders = orders.count;
      } catch (error) {
        console.error(error);
      } finally {
        this.columns = [
          {
            field: "order",
            label: this.$t("lang.admin.print_order.table.order"),
            centered: true
          },
          {
            field: "name",
            label: this.$t("lang.admin.print_order.table.name"),
            centered: true
          },
          {
            field: "date",
            label: this.$t("lang.admin.print_order.table.date"),
            centered: true
          },
          {
            field: "tag_type",
            label: this.$t("lang.admin.print_order.table.tag_type"),
            centered: true
          },
          {
            field: "tag_format",
            label: this.$t("lang.admin.print_order.table.tag_format"),
            centered: true
          },
          {
            field: "status",
            label: this.$t("lang.admin.print_order.table.status"),
            centered: true
          },
          {
            field: "qty",
            label: this.$t("lang.admin.print_order.table.qty"),
            centered: true
          },
          {
            field: "progress",
            label: this.$t("lang.admin.print_order.table.progress"),
            centered: true
          },
          {
            field: "",
            label: this.$t("lang.admin.label_action"),
            centered: true
          }
        ];
        this.shouldLoading = false;
      }
    },
    async printerProgress(id) {
      try {
        let res = await this.$api.printer.printer_progress(id);
        return res.printer_progress;
      } catch (error) {
        console.error(error);
      }
    },
    async deletePrinter(id) {
      try {
        this.shouldLoading = true;
        await this.$api.printer.deletePrinter(id);
      } catch (error) {
        console.error(error);
      } finally {
        this.getData();
      }
    },
    onActionChange(action, row) {
      this.selectedAction = action;
      this.data = this.data.map(item => {
        if (item.id === row.id) {
          item["action"] = this.selectedAction;
        }
      });
    },
    async confirmCancelPrining(id) {
      if (
        await this.$refs.confirm.open(
          `Cancel`,
          `Are you sure to cancel printing ?`,
          this.options
        )
      ) {
        this.onCancelPrint(id);
      }
    },
    async onCancelPrint(id) {
      try {
        this.shouldLoading = true;
        await this.$api.printer.printer_cancel(id);
      } catch (error) {
        console.error(error);
      } finally {
        this.getData();
      }
    }
  }
};
</script>
